export default {"src":"/_next/static/media/greatJob.0d235a26.svg","height":96,"width":260,"blurWidth":0,"blurHeight":0};